// extracted by mini-css-extract-plugin
export default {"event-form":"styles_event-form__Znjti"};